<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                    <el-col :span="16">
                        <el-button-group>
                            <el-button type="info" icon="el-icon-refresh" @click="refreshLocation()">刷新</el-button>
                            <el-button type="info" icon="el-icon-circle-plus" @click="addLocation">添加销售地点</el-button>
                            <el-button @click="downLoad2('销售地点')" type="success">下载表格</el-button>
                        </el-button-group>
                    </el-col>
                    <el-col :span="6" class="serch-input" style="float:right;">
                        <el-input placeholder="请输入地点编号" v-model="input6" class="input-with-select" clearable>
                            <!-- <el-button slot="append" icon="el-icon-search" @click="findUser(input5)"></el-button> -->
                        </el-input>
                    </el-col>
                </el-row>
                <el-row class="locationCode">
                    <el-col :span="24">
                        <el-table
                            v-loading ="loading"
                            element-loading-text = '加载中'
                            :data = 'locationData .filter(data => !input6 || data.locationCode.includes(input6.toUpperCase()))'
                            height="400px"
                            border
                            style="width:100%"
                        >
                            <el-table-column
                                prop="locationCode"
                                label="地点编号"
                                width="100"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="description"
                                label="地点名称"
                                show-overflow-tooltip
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="complimentary"
                                label="免费招待"
                                :formatter="filterComp"
                                width="150"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="lastUpdateDate"
                                label="最后更新日期"
                                show-overflow-tooltip
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="lastUpdateUser"
                                label="最后更新用户"
                                width="120"
                                header-align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="operation"
                                label="操作"
                                header-align="center"
                            >
                                <template slot-scope="scope">
                                    <el-row>
                                        <el-button-group>
                                            <!-- <el-tooltip class="item" effect="dark" content="重置密码" placement="bottom" >
                                                <el-button type="info" size="small" plain icon="el-icon-setting" class="operateBtn"></el-button>
                                            </el-tooltip>-->
                                            <el-tooltip class="item" effect="dark" content="修改" placement="bottom">
                                                <el-button @click.native.prevent="revise(scope.$index,scope.row)" type="info" size="small" plain icon="el-icon-edit"  class="operateBtn"></el-button>
                                            </el-tooltip> 
                                            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                                <el-button type="danger" size="small" icon="el-icon-delete" @click.native.prevent="deleteLocationRow(scope.$index, locationData)" class="operateBtn"></el-button>
                                            </el-tooltip>
                                        </el-button-group>
                                    </el-row>
                                </template>                                             
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    #Console{
        .locationCode{
            margin: 20px 0;
        }
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis';
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            //销售地点
            loading:false,
            input6:"",
            locationData:[
                {
                    locationCode:'',
                    description:'',
                    complimentary:'',
                    lastUpdateDate:'',
                    lastUpdateUser:""
                }
            ]
        }
    },
    created (){
       
    },
    mounted(){
        this.$nextTick(function () {
            this.refreshLocation();
        })
    },
    methods:{
        //下载表格
        downLoad2(name){
           this.isDownTable(this.locationData, this.downLoad ,name);
        },
        /**
         * 格式化:是否免费招待用户
         */
        filterComp(row, column, cellValue, index){
            if(cellValue == 'Y'){
                return '是'
            }else if(cellValue == 'N'){
                return '否'
            }else{
                return ''
            }
        },
        /**
         * 添加销售地点
         */
        addLocation(){
            this.$router.push('addLocation');
        },
        /**
         * 刷新按钮页面
         */
        refreshLocation(){
            this.loading = true;
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findLocations',
                userId
            }
            this.findType(params).then( (res) => {
                // console.log(res)
                if(res.data.status == true){
                    this.loading = false;
                    let result = res.data.list ;
                   // this.sortChinese(result,"description");
                    this.locationData = result ;
                }else{
                    this.loading = false;
                    this.promptMsg('加载失败','提示')
                } 
                
            })
        },
        /**
         * 销售地点删除
        */
        deleteLocationRow(index,rows){
            let code = rows[index].locationCode;
            let userId = sessionStorage.getItem("userId") ;
            this.$confirm('确定删除该账号',"提示",{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                let params = {
                    act : 'delLocation',
                    code:code,
                    userId
                }
                //console.log(params)
                this.delType(params).then((res) => {
                    if(res.data.status == true){
                        this.$message({
                            type: 'success',
                            message: '删除成功 √ '
                        });
                        this.refreshLocation();//刷新页面
                    }else{
                        if(res.data.msg){
                            this.alert(res.data.msg,'warning')
                        }else{
                            this.alert('不能删除 !','warning')
                        }
                    }
                })
            }).catch((error) => {
                this.$message({
                    type:'info',
                    message:'已取消删除'
                })
            })
        },

        /**
         * 修改销售地点
        */
        revise(index,rows){
            let locationCode = rows.locationCode ;
            this.getUserIndex("findLocations",elem => elem.locationCode == locationCode).then((res) => {
                this.$router.push({
                    path:'/system/editLocation',
                    query:{
                        index:res
                    }
                })
            })
            
        }

    }
}
</script>
